<div class="manage-users-headers">
  <div class="page-title">Lead Status Logs</div>
  @if (LeadStatusLog.length > 0) {
    <div class="page-size">
      <app-page-size
        [pageSize]="pageSize"
        [selectId]="'lead-status-logs'"
        (pageSizeChanged)="onPageSizeChange($event)"
      ></app-page-size>
    </div>
  }
</div>

<div class="filter-search-section">
  <div class="lead-status-filters-container">
    <div class="lead-status-filters">
      <div class="filter-card">
        <div class="filter-card-content">
          <app-filter
            [filterBy]="filterByConnection"
            [filterByOptions]="filterByConnectionOptions"
            [label]="'Filter by Connection'"
            (filterByChanged)="onFilterByConnectionChange($event)"
          ></app-filter>
        </div>
      </div>

      <div class="filter-card">
        <div class="filter-card-content">
          <app-filter
            [filterBy]="filterByLeadStatus"
            [filterByOptions]="filterByLeadStatusOptions"
            [label]="'Filter by Status'"
            (filterByChanged)="onFilterByLeadStatusChange($event)"
          ></app-filter>
        </div>
      </div>
    </div>

    <div class="search-section-wrapper">
      <div class="search-section">
        <app-svg-icon [iconName]="'search.svg'" class="svg"></app-svg-icon>
        <input
          type="text"
          placeholder="Search Business ..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchQueryChange($event)"
        />
      </div>
    </div>
  </div>
</div>

<app-lead-status-logs-dashboards
  [connectionId]="
    filterByConnection !== 'all' ? +filterByConnection : undefined
  "
  [status]="filterByLeadStatus !== '' ? +filterByLeadStatus : undefined"
  (leadStatusClicked)="onDashboardStatusClick($event)"
></app-lead-status-logs-dashboards>

<app-table [columns]="tableColumns" [data]="LeadStatusLog" [loading]="loading">
  <ng-template let-leadStatus>
    <tr>
      <td class="business-name">
        {{ leadStatus.business_name }}
      </td>
      <td>
        {{ leadStatus.connection?.display_name }}
      </td>
      <td>
        {{
          leadStatus.updated_by?.first_name
            ? (
                leadStatus.updated_by.first_name +
                " " +
                (leadStatus.updated_by.last_name || "")
              ).trim()
            : ""
        }}
      </td>
      <td>
        <span
          class="status-badge {{ getLeadStatusClass(leadStatus.lead_status) }}"
        >
          {{ getLeadStatusLabel(leadStatus.lead_status) }}
        </span>
      </td>
      <td class="date-column">
        {{
          leadStatus.updated_on_utc
            ? (leadStatus.updated_on_utc | date: "medium")
            : ""
        }}
      </td>
      <td>
        <a
          href="javascript:void(0)"
          class="view-button"
          (click)="viewRecordDetails(leadStatus.unique_id)"
        >
          View
        </a>
      </td>
    </tr>
  </ng-template>
</app-table>

@if (LeadStatusLog.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalLeadStatusLogs"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showRecordDetails) {
  <app-record-details
    [unique_id]="uniqueId"
    (popupClosed)="showRecordDetails = false"
  ></app-record-details>
}
